module.exports = __webpack_public_path__ + "static/media/06-usa.cb06a721.png";